//#region Libraries
import styled from "styled-components";
//#endregion

export const Title = styled.h2`
    margin: 0;
`;
export const HeaderTop = styled.section`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
`;